<script setup>
import { computed } from 'vue'

const props = defineProps(['text'])

// textが存在するときだけ変換処理を行う算出プロパティを作成
const formattedText = computed(() => {
  // props.text が無い(null/undefined/空)場合は、空文字を返す
  if (!props.text) {
    return ''
  }
  // props.text がある場合のみ、改行を<br>に置換(/\r\n|\r|\n/)
  return props.text.replace(/(\r\n|\r|\n)/g, '<br>')
})
</script>

<template>
  <div v-if="props.text" v-html="formattedText"></div>
</template>